module.exports = __webpack_public_path__ + "media/images/athletes/2839-87dfc321ac71a6bf3f861f47a7232a51.png";